import { useQuery } from '@tanstack/react-query';
import api from '../services/authService';

export const useAdminInfrastructure = () => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['adminInfrastructure'],
    queryFn: async () => {
      const response = await api.get('/admin/infrastructure');
      return response.data;
    },
    staleTime: 60 * 1000,
    refetchInterval: 60 * 1000,
  });

  return {
    infrastructure: data?.data || null,
    isLoading,
    error,
    refetch,
  };
};
